const FOR_YOU = [
  'Tu as entre 18 et 30 ans.',
  'Tu pars de zéro, ou tu plafonnes sous les 5\u00A0000€/mois.',
  'Tu veux un business simple à mettre en place, où tu es accompagné de A à Z pour aller chercher tes 5\u00A0000€/mois en 90\u00A0jours.',
];

const NOT_FOR_YOU = [
  'Tu cherches une solution gratuite à tes problèmes.',
  'Ou si tu cherches un plan sous rapide et pas sérieux du tout.',
];

export const Audience = () => {
  return (
    <section data-testid="audience" className="px-5 md:px-8 py-6 md:py-12 bg-[#0D1F17]">
      <div className="max-w-5xl mx-auto flex flex-col gap-8">
        <h2 className="text-[26px] sm:text-3xl md:text-5xl leading-[1.1] max-w-2xl">
          Ce programme est fait pour certains,{' '}
          <span className="font-serif-italic font-normal italic">
            pas pour tout le monde.
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <article className="card-forest flex flex-col gap-4" style={{ padding: 24 }}>
            <p className="microlabel">C&rsquo;est pour toi si</p>
            <div className="flex flex-col" style={{ gap: 14 }}>
              {FOR_YOU.map((line) => (
                <p key={line} className="text-[#F5EFE3]/85" style={{ fontSize: 16, lineHeight: 1.55 }}>
                  {line}
                </p>
              ))}
            </div>
          </article>

          <article className="card-forest flex flex-col gap-4" style={{ padding: 24, background: 'rgba(0,0,0,0.15)' }}>
            <p className="microlabel" style={{ color: 'rgba(245, 239, 227, 0.35)' }}>
              Ce n&rsquo;est pas pour toi si
            </p>
            <div className="flex flex-col" style={{ gap: 14 }}>
              {NOT_FOR_YOU.map((line) => (
                <p key={line} className="text-[#F5EFE3]/50" style={{ fontSize: 16, lineHeight: 1.55 }}>
                  {line}
                </p>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Audience;
